import {
  Container,
  H1,
  RowWrapper,
  SubText,
  Tile,
} from "components/styled-components/generic";
import { Tooltip } from "components/styled-components/tooltip";
import { disclaimerWltp } from "constants/disclaimers";
import { FC } from "react";
import { Car } from "shared-types";
import cls from "./index.module.css";

export interface WltpOverviewProps {
  selectedModel: Car;
}

export const WltpOverview: FC<WltpOverviewProps> = ({ selectedModel }) => {
  return (
    <Container>
      <RowWrapper>
        <div className={cls["wlt-wrapper"]}>
          <H1>
            WLTP-Werte
            <Tooltip id="wltp" tip={disclaimerWltp} />
          </H1>
          <div className={cls["car-summary"]}>
            <Tile>
              <SubText>Kapazität</SubText>
              <SubText>
                {selectedModel.power
                  ? selectedModel.power.toLocaleString("de")
                  : "-"}{" "}
                kWh
              </SubText>
            </Tile>
            <Tile>
              <SubText>Verbrauch</SubText>
              <SubText>
                {selectedModel.consumption
                  ? selectedModel.consumption.toLocaleString("de")
                  : "-"}{" "}
                kWh/100 km
              </SubText>
            </Tile>
            <Tile>
              <SubText>Reichweite</SubText>
              <SubText>
                {selectedModel.range
                  ? selectedModel.range.toLocaleString("de")
                  : "-"}{" "}
                km
              </SubText>
            </Tile>
          </div>
        </div>
      </RowWrapper>
    </Container>
  );
};
